<template>
  <div class="mobile-floating">
    <!-- 플로팅 버튼 -->
    <button class="floating-btn" @click="openModal">
      <img src="@/assets/floating/1.gif" alt="영상보기" />
    </button>

    <!-- 버건디 모달 -->
    <transition name="modal">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-wrapper">
          <!-- 닫기 버튼 -->
          <button class="close-btn" @click="closeModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <!-- 이미지 (버건디 박스 위) -->
          <div class="modal-image">
            <img src="@/assets/popup/home2.png" alt="청주 레이원시티 홍보관 상담센터" />
          </div>

          <!-- 버건디 박스 (영상만 포함) -->
          <div class="modal-content">
            <div class="modal-video">
              <iframe
                src="https://www.youtube.com/embed/yWVeR23uK6A?autoplay=1&mute=1&playsinline=1"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MobileFloatingButton',
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    openModal() {
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.showModal = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
/* 플로팅 버튼 */
.floating-btn {
  position: fixed;
  bottom: 55px;
  left: 20px;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  z-index: 800;
  transition: transform 0.3s ease;
}

.floating-btn:active {
  transform: scale(0.95);
}

.floating-btn img {
  width: auto;
  height: 80px;
  display: block;
}

/* 모달 오버레이 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
}

/* 모달 래퍼 */
.modal-wrapper {
  position: relative;
  width: 100%;
  max-width: 400px;
}

/* 닫기 버튼 - 바깥 배치 */
.close-btn {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 36px;
  height: 36px;
  background: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--rayone-primary);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

/* 이미지 영역 (버건디 박스 위) - 반짝이 효과 */
.modal-image {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.modal-image img {
  width: 100%;
  height: auto;
  display: block;
}

.modal-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent 0%,
    transparent 30%,
    rgba(255, 255, 255, 0.4) 50%,
    transparent 70%,
    transparent 100%
  );
  animation: shine 2.5s ease-in-out infinite;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 150%;
  }
}

/* 버건디 박스 (영상 포함) */
.modal-content {
  background: var(--rayone-primary);
  padding: 16px;
}

/* 동영상 영역 */
.modal-video {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 8px;
}

.modal-video iframe {
  width: 100%;
  height: 100%;
}

/* 모달 애니메이션 */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .modal-wrapper,
.modal-leave-active .modal-wrapper {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-wrapper,
.modal-leave-to .modal-wrapper {
  transform: scale(0.9);
  opacity: 0;
}
</style>
